import { sharedTracker } from '../Tracker'
import events from '../events'

export const trackClickedPaywallChip = (
	{ planName, feature }: { planName: string, feature: string }
) => sharedTracker
	.trackPaywallAction( {
		action: events.paywall.CLICKED_PAYWALL_CHIP,
		chip_plan_name: planName,
		feature
	} );
